var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useState } from 'react';
import ExcursionToolbar from './ExcursionToolbar';
import { addExcursionToCart, fetchExcursionAvailabilityApprox, fetchExcursionPrice } from 'api-ito/ExcursionsApi';
import { appUrl } from 'utils';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import { api } from '../../../include/network/network';
import _ from 'lodash';
import { BackdropContext } from '../../../include/react-components/BackdropProvider';
export default function ExcursionToolbarContainer(props) {
    const [date, setDate] = useState(null);
    const [adultCount, setAdultCount] = useState(2);
    const [childAges, setChildAges] = useState([]);
    const [vehicleTypeId, setVehicleTypeId] = useState(null);
    const [prices, setPrices] = useState(null);
    const [selectedPrice, setSelectedPrice] = useState();
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const history = useHistory();
    const backdrop = useContext(BackdropContext);
    const handleChange = (newDate, newAdultCount, newChildAges, price) => {
        const vehicleTypeId = price && price.vehicleTypeId ? price.vehicleTypeId : null;
        setDate(newDate);
        setAdultCount(newAdultCount);
        setChildAges(newChildAges);
        setVehicleTypeId(vehicleTypeId);
        if (newDate) {
            const params = serializeWidgetParams(newDate, newAdultCount, newChildAges, vehicleTypeId);
            history.replace({ search: params.toString() });
        }
    };
    // Восстановление параметров поиска из url.
    useEffect(() => {
        const params = restoreWidgetParams(location.search);
        if (!params)
            return;
        setDate(params.date);
        setAdultCount(params.adultCount);
        setChildAges(params.childAges);
        setVehicleTypeId(parseInt(params.vehicleTypeId || '') || null);
    }, [location.search]);
    // Поиск цены. Выполняется при изменении любого из параметров.
    useEffect(() => {
        let abort = false;
        if (!date)
            return;
        setLoading(true);
        fetchExcursionPrice(props.excursionId, date, adultCount, childAges, undefined).then((response) => {
            if (abort)
                return;
            if ('errors' in response) {
                console.log('fetchExcursionPrice', response.errors);
                setPrices([]);
            }
            else {
                setPrices(response);
            }
        }).catch((err) => {
            if (!abort) {
                console.error('fetchExcursionPrice exception', err);
                setPrices([]);
            }
        }).finally(() => !abort && setLoading(false));
        return () => { abort = true; };
    }, [date, adultCount, childAges.map(x => `${x.age}${(x.withPlace ? '*' : '')}`).join(',')]);
    // Пост-фильтрация цен по транспорту.
    useEffect(() => {
        if (prices && prices.length) {
            // Выбираем цену с самым подходящим транспортом и самой дешевой ценой.
            const matchingPrices = vehicleTypeId
                ? prices.filter(x => x.vehicleTypeId == vehicleTypeId)
                : prices;
            const matchingPrice = matchingPrices.length
                ? matchingPrices.sort((a, b) => a.price - b.price)[0]
                : prices[0];
            setSelectedPrice(matchingPrice);
        }
        else {
            setSelectedPrice(null);
        }
    }, [prices, vehicleTypeId]);
    const loadAvailability = (monthIso) => __awaiter(this, void 0, void 0, function* () {
        const result = yield fetchExcursionAvailabilityApprox(props.excursionId, monthIso);
        return !('errors' in result) ? result : [];
    });
    const book = () => __awaiter(this, void 0, void 0, function* () {
        if (!selectedPrice || !date)
            return;
        // TODO: booking & booking errors.
        yield addExcursionToCart(props.excursionId, date, adultCount, childAges, selectedPrice.secureSerialized);
        window.location.href = appUrl('/Cart');
    });
    const frameBook = () => __awaiter(this, void 0, void 0, function* () {
        if (!selectedPrice || !date)
            return;
        backdrop.show();
        const cart = JSON.parse(sessionStorage.getItem('frame-cart') || '{ "services": [] }');
        cart.services = [];
        const r = yield api('post', `/frame/${props.frameId}/excursion-cart${props.tempFrameId ? `?tempId=${props.tempFrameId}` : ''}`, { excursionId: props.excursionId, date, adultCount, childAges, excursionSerialized: selectedPrice.secureSerialized });
        if (r.errors) {
            backdrop.hide();
            return;
        }
        cart.services.push({ type: 'excursion', excursionId: props.excursionId, date, adultCount, childAges, excursionSerialized: selectedPrice.secureSerialized, cartData: r.response });
        const serviceDatas = cart.services.flatMap(s => s.type == 'hotel' ? [...s.cartData.map(x => x), ...s.cartDataCompulsory.map(x => x)] : [s.cartData]);
        cart.price = _.sum(_.map(serviceDatas, s => s.priceInBookingCurrency));
        cart.pricePerPerson = _.sum(_.map(serviceDatas, s => (s.priceInBookingCurrency / (s.accommodation.adults + s.accommodation.childs))));
        cart.currency = r.response.bookingCurrency;
        sessionStorage.setItem('frame-cart', JSON.stringify(cart));
        if (props.bookCallback)
            props.bookCallback();
        backdrop.hide();
    });
    useEffect(() => {
        if (!props.frameId)
            return;
        const params = new URLSearchParams(location.search);
        if (params.get('cartOpen') != "true")
            return;
        //(async () => {
        //    const r = await api<CartExcursionData, undefined>('post', `/frame/${props.frameId}/excursion-cart${props.tempFrameId ? `?tempId=${props.tempFrameId}` : ''}`, { excursionId: props.excursionId, date, adultCount, childAges, excursionSerialized: selectedPrice.secureSerialized });
        //    if (r.errors) {
        //        backdrop.hide();
        //        return;
        //    }
        //    const tempCart = JSON.parse(sessionStorage.getItem('frame-cart') || '{ "services": [] }') as CartFrameProps;
        //    if (props.bookCallback && tempCart?.services?.length)
        //        props.bookCallback();
        //})();
        frameBook();
    }, [selectedPrice, date]);
    return React.createElement("div", null,
        React.createElement(ExcursionToolbar, { date: date, adultCount: adultCount, childAges: childAges, loading: loading, prices: prices, price: selectedPrice, onChange: handleChange, onAvailabilityRequest: loadAvailability, onBook: props.frameId ? frameBook : book }));
}
function serializeWidgetParams(date, adultCount, childAges, vehicleTypeId) {
    const params = new URLSearchParams();
    params.set('date', date);
    params.set('adc', adultCount.toString());
    if (childAges.length)
        params.set('cag', childAges.map(c => `${c.age}${(c.withPlace ? '*' : '')}`).join(','));
    if (vehicleTypeId)
        params.set('vtid', vehicleTypeId.toString());
    return params;
}
function restoreWidgetParams(search) {
    if (!search)
        return null;
    const params = new URLSearchParams(search);
    const adc = params.get('adc'), // adult count
    cha = params.get('cag'), // child ages
    dte = params.get('date'), // excursion date
    vtid = params.get('vtid'); // vehicle type id
    if (!adc || !dte)
        return null;
    const adultCount = parseInt(adc);
    const childAges = cha && cha.split(',').map(x => ({ age: parseInt(x), withPlace: (x[x.length - 1] == '*') })) || [];
    const date = moment(dte);
    if (!adultCount || !date.isValid() || (childAges && childAges.findIndex(x => isNaN(x.age)) != -1))
        return null;
    return { adultCount, childAges, date: date.format('YYYY-MM-DD'), vehicleTypeId: vtid };
}
